<bic-popup (close)="close()" [hasBackdrop]="true" [title]="'Möchten Sie das Projekt '+ '“' +data.project.name + '”' +' wirklich löschen?'" customClass="w-[560px] h-fit">
  <div bicPopupContent class="flex flex-col">
    <span class="font-normal">Bei Bestätigung wird das Projekt “{{ data.project.name }}” unwiderruflich gelöscht. Alle Mitglieder verlieren mit sofortiger Wirkung den Zugriff auf Projektdaten, Prüfergebnisse und die Projektverwaltung. </span>
  </div>
  <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
    <bic-button (onClick)="close()" buttonType="white">Abbrechen</bic-button>
    <bic-button (onClick)="deleteProject()" buttonType="red">Löschen</bic-button>
  </div>
</bic-popup>
